var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugCssSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,21C9.5703125,21,8,22.5703125,8,24.5S9.5703125,28,11.5,28s3.5-1.5703125,3.5-3.5S13.4296875,21,11.5,21z M11.5,26 c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S12.3271484,26,11.5,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,21c-1.9296875,0-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5s3.5-1.5703125,3.5-3.5S22.4296875,21,20.5,21z  M20.5,26c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S21.3271484,26,20.5,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2900391,19.4716797C28.6611328,16.8955078,30,13.5107422,30,10c0-3.6259766-1.3896484-7.0683594-3.9121094-9.6933594 C25.8994141,0.1113281,25.6396484,0,25.3671875,0H6.6328125C6.3603516,0,6.1005859,0.1113281,5.9121094,0.3066406 C3.3896484,2.9316406,2,6.3740234,2,10c0,3.5107422,1.3388672,6.8955078,3.7099609,9.4716797 C4.0126953,20.7822266,3,22.8017578,3,25c0,3.859375,3.140625,7,7,7h12c3.859375,0,7-3.140625,7-7 C29,22.8017578,27.9873047,20.7822266,26.2900391,19.4716797z M22,30H10c-2.7568359,0-5-2.2431641-5-5 c0-1.8955078,1.0556641-3.6054688,2.7548828-4.4628906c0.2949219-0.1484375,0.4970703-0.4326172,0.5410156-0.7597656 s-0.0761719-0.6542969-0.3212891-0.875C5.4482422,16.6230469,4,13.3789062,4,10c0-2.9677734,1.0869141-5.7919922,3.0683594-8 h17.8632812C26.9130859,4.2080078,28,7.0322266,28,10c0,3.3789062-1.4482422,6.6230469-3.9746094,8.9023438 c-0.2451172,0.2207031-0.3652344,0.5478516-0.3212891,0.875s0.2460938,0.6113281,0.5410156,0.7597656 C25.9443359,21.3945312,27,23.1044922,27,25C27,27.7568359,24.7568359,30,22,30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugCssSmall);
export default __webpack_public_path__ + "static/media/plug-css--small.301be084308be76d57855e4d71a93456.svg";
export { ForwardRef as ReactComponent };